module.exports = __webpack_public_path__ + "packs/media/images/sponsors/climberstore-d54337daf1d4dc969c958a2309bf4bd9.png";